import * as tslib_1 from "tslib";
import { observable } from 'mobx';
var Loadable = /** @class */ (function () {
    function Loadable() {
    }
    tslib_1.__decorate([
        observable
    ], Loadable.prototype, "isBusy", void 0);
    return Loadable;
}());
export { Loadable };
export function loading(target, propertyKey, descriptor) {
    var func = descriptor.value;
    descriptor.value = function () {
        var source = this;
        source.isBusy = true;
        var done = function () { return source.isBusy = false; };
        var promise = func.apply(source, arguments);
        promise.then(done);
        promise.catch(done);
        return promise;
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/loading.ts
// module id = 88
// module chunks = 0